export default {
    base: process.env.VUE_APP_API,
    baseFl: process.env.VUE_APP_STORAGE,
    secret: 'ADeuCasb4fDkdakK5IJas3CQ5h0TfrWGbiyHbYHBBIblitnj545GHdnrcdgNS6Q',
    secretFl : 'ADeuASAfdDsadkdakK5IJas3CQ5h0TfrWGbiyHbYHBBIblitndsadJAHSASA7632bnsys7cx3'
}

//base : http://api.zax.co.id
//fl base : http://storage.zax.co.id